import { imageSrc } from '@/api/agreements';

export { imageSrc };
export { detail } from '@/components/estimating/assemblies/assemblyFormat';

// Client money is integer cents (contingency already spread in, to the cent).
export const usd = (c) => `$${(Number(c || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const DETAILS = [
  { value: 'itemized', label: 'Itemized lines', hint: 'Every line with its name, description and price.' },
  { value: 'sections', label: 'Service totals', hint: 'One total per service; each line shows its name and description, without a price.' },
  { value: 'lump', label: 'One lump sum', hint: 'One total; lines show their name and description, without prices.' },
];

export const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;
export const longDate = (ymd) => (ymd ? new Date(`${ymd}T12:00:00`).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : '');
export const isStale = (e) => e?.response?.status === 409 && !!e?.response?.data?.stale;
// Loop D14: out for signature / signed → every composer write is 409 {detail, code, locked: true}.
export const isLocked = (e) => e?.response?.status === 409 && !!e?.response?.data?.locked;
